const MUTE_KEY = "msg_sound_muted";
let activeConvoId = null;
let ctx = null;

export const setActiveConvo = (id) => { activeConvoId = id || null; };
export const isActiveConvo = (id) => activeConvoId === id && document.visibilityState === "visible";
export const isMuted = () => localStorage.getItem(MUTE_KEY) === "1";
export const setMuted = (v) => localStorage.setItem(MUTE_KEY, v ? "1" : "0");

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Les navigateurs bloquent l'audio tant que l'utilisateur n'a pas interagi : on débloque au 1er geste.
export const unlockAudio = () => {
  const handler = () => {
    const c = getCtx();
    if (c && c.state === "suspended") c.resume().catch(() => {});
    window.removeEventListener("pointerdown", handler);
    window.removeEventListener("keydown", handler);
  };
  window.addEventListener("pointerdown", handler);
  window.addEventListener("keydown", handler);
};

export const playPing = () => {
  if (isMuted()) return;
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const t = c.currentTime;
  [[880, 0], [1318.5, 0.12]].forEach(([f, d]) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "sine";
    o.frequency.value = f;
    g.gain.setValueAtTime(0.0001, t + d);
    g.gain.exponentialRampToValueAtTime(0.12, t + d + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + d + 0.35);
    o.connect(g).connect(c.destination);
    o.start(t + d);
    o.stop(t + d + 0.4);
  });
};

export const requestNotifPermission = () => {
  if (!("Notification" in window) || Notification.permission !== "default") return;
  const ask = () => {
    Notification.requestPermission().catch(() => {});
    window.removeEventListener("pointerdown", ask);
  };
  window.addEventListener("pointerdown", ask);
};

export const showMsgNotification = async (sender, onClick) => {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  const title = `Nouveau message de ${sender.from_name || "PACAZUR"}`;
  const opts = { body: (sender.last_body || "Pièce jointe").slice(0, 140), icon: "/icons/icon-192.png", tag: `msg-${sender.from_id}`,
    data: { userId: sender.from_id, name: sender.from_name || "" } };
  try {
    const n = new Notification(title, opts);
    n.onclick = () => { window.focus(); onClick(); n.close(); };
  } catch {
    // Android/PWA : le constructeur est interdit, on passe par le service worker.
    const reg = await navigator.serviceWorker?.ready;
    reg?.showNotification(title, opts);
  }
};
